//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import AxiosClient from "./axiosClient";import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    getApiPing( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetApiPing(_response));
        });
    }

    protected processGetApiPing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApplicationsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    listForClient(clientId: string | undefined, cancelToken?: CancelToken): Promise<ListResponseOfApplicationModel> {
        let url_ = this.baseUrl + "/api/Applications/list?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListForClient(_response));
        });
    }

    protected processListForClient(response: AxiosResponse): Promise<ListResponseOfApplicationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfApplicationModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfApplicationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfApplicationModel>(null as any);
    }

    create(clientId: string | undefined, model: CreateApplication, cancelToken?: CancelToken): Promise<SingleResponseOfApplicationModel> {
        let url_ = this.baseUrl + "/api/Applications?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<SingleResponseOfApplicationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfApplicationModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfApplicationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfApplicationModel>(null as any);
    }

    update(clientId: string | undefined, applicationId: string, model: ApplicationModel, cancelToken?: CancelToken): Promise<SingleResponseOfApplicationModel> {
        let url_ = this.baseUrl + "/api/Applications/{applicationId}?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<SingleResponseOfApplicationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfApplicationModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfApplicationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfApplicationModel>(null as any);
    }

    delete(clientId: string | undefined, applicationId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Applications/{applicationId}?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApplicationUserClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    login(request: AuthRequest, cancelToken?: CancelToken): Promise<SingleResponseOfAuthResponse> {
        let url_ = this.baseUrl + "/api/ApplicationUser/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogin(_response));
        });
    }

    protected processLogin(response: AxiosResponse): Promise<SingleResponseOfAuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfAuthResponse.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfAuthResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfAuthResponse>(null as any);
    }

    impersonate(request: ImpersonationRequest, cancelToken?: CancelToken): Promise<SingleResponseOfAuthResponse> {
        let url_ = this.baseUrl + "/api/ApplicationUser/impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processImpersonate(_response));
        });
    }

    protected processImpersonate(response: AxiosResponse): Promise<SingleResponseOfAuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfAuthResponse.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfAuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfAuthResponse>(null as any);
    }

    refreshToken(request: RefreshRequest, cancelToken?: CancelToken): Promise<SingleResponseOfAuthResponse> {
        let url_ = this.baseUrl + "/api/ApplicationUser/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRefreshToken(_response));
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<SingleResponseOfAuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfAuthResponse.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfAuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfAuthResponse>(null as any);
    }

    logout(refreshToken: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/ApplicationUser/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(refreshToken);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogout(_response));
        });
    }

    protected processLogout(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    forgotPassword(request: ForgotPasswordRequest, cancelToken?: CancelToken): Promise<SingleResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/ApplicationUser/forgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processForgotPassword(_response));
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<SingleResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfBoolean>(null as any);
    }

    resetPassword(request: ResetPasswordRequest, cancelToken?: CancelToken): Promise<SingleResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/ApplicationUser/resetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResetPassword(_response));
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<SingleResponseOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfBoolean.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfBoolean>(null as any);
    }
}

export class ClientClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    getClient(clientId: string | undefined, cancelToken?: CancelToken): Promise<SingleResponseOfClientModel> {
        let url_ = this.baseUrl + "/api/Client?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClient(_response));
        });
    }

    protected processGetClient(response: AxiosResponse): Promise<SingleResponseOfClientModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfClientModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfClientModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfClientModel>(null as any);
    }

    createClient(name: string | null | undefined, mainThemeColor: string | null | undefined, mainThemeTextColor: string | null | undefined, workingDays: DaysOfWeek[] | null | undefined, jobSchedulerTimeIntervals: number | null | undefined, logo: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<SingleResponseOfClientModel> {
        let url_ = this.baseUrl + "/api/Client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (mainThemeColor !== null && mainThemeColor !== undefined)
            content_.append("MainThemeColor", mainThemeColor.toString());
        if (mainThemeTextColor !== null && mainThemeTextColor !== undefined)
            content_.append("MainThemeTextColor", mainThemeTextColor.toString());
        if (workingDays !== null && workingDays !== undefined)
            workingDays.forEach(item_ => content_.append("WorkingDays", item_.toString()));
        if (jobSchedulerTimeIntervals !== null && jobSchedulerTimeIntervals !== undefined)
            content_.append("JobSchedulerTimeIntervals", jobSchedulerTimeIntervals.toString());
        if (logo !== null && logo !== undefined)
            content_.append("logo", logo.data, logo.fileName ? logo.fileName : "logo");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateClient(_response));
        });
    }

    protected processCreateClient(response: AxiosResponse): Promise<SingleResponseOfClientModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfClientModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfClientModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfClientModel>(null as any);
    }

    deleteClient(clientId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Client?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteClient(_response));
        });
    }

    protected processDeleteClient(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    listClients( cancelToken?: CancelToken): Promise<ListResponseOfClientModel> {
        let url_ = this.baseUrl + "/api/Client/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListClients(_response));
        });
    }

    protected processListClients(response: AxiosResponse): Promise<ListResponseOfClientModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfClientModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfClientModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfClientModel>(null as any);
    }

    updateClient(clientId: string, model: ClientModel, cancelToken?: CancelToken): Promise<SingleResponseOfClientModel> {
        let url_ = this.baseUrl + "/api/Client/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateClient(_response));
        });
    }

    protected processUpdateClient(response: AxiosResponse): Promise<SingleResponseOfClientModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfClientModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfClientModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfClientModel>(null as any);
    }

    getClientLogo(uniqueId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Client/logo/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetClientLogo(_response));
        });
    }

    protected processGetClientLogo(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setClientLogo(clientId: string, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<SingleResponseOfClientModel> {
        let url_ = this.baseUrl + "/api/Client/{clientId}/logo";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetClientLogo(_response));
        });
    }

    protected processSetClientLogo(response: AxiosResponse): Promise<SingleResponseOfClientModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfClientModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfClientModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfClientModel>(null as any);
    }
}

export class ContactClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    createContact(clientId: string, customerId: string, model: UpdateContactModel, cancelToken?: CancelToken): Promise<SingleResponseOfContactModel> {
        let url_ = this.baseUrl + "/api/Contact/{clientId}/{customerId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateContact(_response));
        });
    }

    protected processCreateContact(response: AxiosResponse): Promise<SingleResponseOfContactModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfContactModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfContactModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfContactModel>(null as any);
    }

    updateContact(clientId: string, customerId: string, contactId: string, model: UpdateContactModel, cancelToken?: CancelToken): Promise<SingleResponseOfContactModel> {
        let url_ = this.baseUrl + "/api/Contact/{clientId}/{customerId}/{contactId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateContact(_response));
        });
    }

    protected processUpdateContact(response: AxiosResponse): Promise<SingleResponseOfContactModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfContactModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfContactModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfContactModel>(null as any);
    }

    deleteContact(clientId: string, customerId: string, contactId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Contact/{clientId}/{customerId}/{contactId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteContact(_response));
        });
    }

    protected processDeleteContact(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CustomersClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    listForClient(filterSort: CustomerFilterSort, cancelToken?: CancelToken): Promise<ListResponseOfCustomerModel> {
        let url_ = this.baseUrl + "/api/Customers/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterSort);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListForClient(_response));
        });
    }

    protected processListForClient(response: AxiosResponse): Promise<ListResponseOfCustomerModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfCustomerModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfCustomerModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfCustomerModel>(null as any);
    }

    listJobSitesForClient(filterSort: JobSiteFilterSort, cancelToken?: CancelToken): Promise<ListResponseOfJobSiteModel> {
        let url_ = this.baseUrl + "/api/Customers/jobsites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterSort);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListJobSitesForClient(_response));
        });
    }

    protected processListJobSitesForClient(response: AxiosResponse): Promise<ListResponseOfJobSiteModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfJobSiteModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfJobSiteModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfJobSiteModel>(null as any);
    }

    listContactsForClient(clientId: string | undefined, customerId: string | undefined, cancelToken?: CancelToken): Promise<ListResponseOfContactModel> {
        let url_ = this.baseUrl + "/api/Customers/contacts?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListContactsForClient(_response));
        });
    }

    protected processListContactsForClient(response: AxiosResponse): Promise<ListResponseOfContactModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfContactModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfContactModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfContactModel>(null as any);
    }

    addCustomer(clientId: string, model: UpdateCustomerModel, cancelToken?: CancelToken): Promise<SingleResponseOfCustomerModel> {
        let url_ = this.baseUrl + "/api/Customers/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddCustomer(_response));
        });
    }

    protected processAddCustomer(response: AxiosResponse): Promise<SingleResponseOfCustomerModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfCustomerModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfCustomerModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfCustomerModel>(null as any);
    }

    updateCustomer(clientId: string, customerId: string, model: UpdateCustomerModel, cancelToken?: CancelToken): Promise<SingleResponseOfCustomerModel> {
        let url_ = this.baseUrl + "/api/Customers/{clientId}/{customerId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateCustomer(_response));
        });
    }

    protected processUpdateCustomer(response: AxiosResponse): Promise<SingleResponseOfCustomerModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfCustomerModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfCustomerModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfCustomerModel>(null as any);
    }

    deleteCustomer(clientId: string, customerId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Customers/{clientId}/{customerId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteCustomer(_response));
        });
    }

    protected processDeleteCustomer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DriversClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    listForClient(clientId: string | undefined, cancelToken?: CancelToken): Promise<ListResponseOfDriverModel> {
        let url_ = this.baseUrl + "/api/Drivers/list?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListForClient(_response));
        });
    }

    protected processListForClient(response: AxiosResponse): Promise<ListResponseOfDriverModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfDriverModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfDriverModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfDriverModel>(null as any);
    }

    getDriver(clientId: string, driverId: string, cancelToken?: CancelToken): Promise<SingleResponseOfDriverModel> {
        let url_ = this.baseUrl + "/api/Drivers/{clientId}/{driverId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (driverId === undefined || driverId === null)
            throw new Error("The parameter 'driverId' must be defined.");
        url_ = url_.replace("{driverId}", encodeURIComponent("" + driverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDriver(_response));
        });
    }

    protected processGetDriver(response: AxiosResponse): Promise<SingleResponseOfDriverModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfDriverModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfDriverModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfDriverModel>(null as any);
    }
}

export class JobDriverClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    setStatus(model: JobDriverStatusModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/JobDriver/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetStatus(_response));
        });
    }

    protected processSetStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class JobsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    listDashboardJobsForClient(clientId: string | undefined, cancelToken?: CancelToken): Promise<ListResponseOfJobModel> {
        let url_ = this.baseUrl + "/api/Jobs/dashboard?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListDashboardJobsForClient(_response));
        });
    }

    protected processListDashboardJobsForClient(response: AxiosResponse): Promise<ListResponseOfJobModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfJobModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfJobModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfJobModel>(null as any);
    }

    getFirstDeliveryDateForDate(clientId: string | undefined, date: Date | undefined, cancelToken?: CancelToken): Promise<SingleResponseOfNullableDateTimeOffset> {
        let url_ = this.baseUrl + "/api/Jobs/delivery?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetFirstDeliveryDateForDate(_response));
        });
    }

    protected processGetFirstDeliveryDateForDate(response: AxiosResponse): Promise<SingleResponseOfNullableDateTimeOffset> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfNullableDateTimeOffset.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfNullableDateTimeOffset>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfNullableDateTimeOffset>(null as any);
    }

    listJobsForCustomer(model: JobsForCustomer, cancelToken?: CancelToken): Promise<ListResponseOfJobModel> {
        let url_ = this.baseUrl + "/api/Jobs/customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListJobsForCustomer(_response));
        });
    }

    protected processListJobsForCustomer(response: AxiosResponse): Promise<ListResponseOfJobModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfJobModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfJobModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfJobModel>(null as any);
    }

    listJobsForCalendar(model: JobsForCalendar, cancelToken?: CancelToken): Promise<ListResponseOfJobModel> {
        let url_ = this.baseUrl + "/api/Jobs/calendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListJobsForCalendar(_response));
        });
    }

    protected processListJobsForCalendar(response: AxiosResponse): Promise<ListResponseOfJobModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfJobModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfJobModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfJobModel>(null as any);
    }

    searchJobs(clientId: string | undefined, model: JobSearchFilter, cancelToken?: CancelToken): Promise<ListResponseOfJobModel> {
        let url_ = this.baseUrl + "/api/Jobs/search?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSearchJobs(_response));
        });
    }

    protected processSearchJobs(response: AxiosResponse): Promise<ListResponseOfJobModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfJobModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfJobModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfJobModel>(null as any);
    }

    deleteJob(clientId: string | undefined, jobId: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Jobs?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (jobId === null)
            throw new Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteJob(_response));
        });
    }

    protected processDeleteJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    cancelJob(model: CancelJobModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Jobs/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCancelJob(_response));
        });
    }

    protected processCancelJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    completeJob(model: CompleteJobModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Jobs/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCompleteJob(_response));
        });
    }

    protected processCompleteJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateOrder(model: UpdateOrderModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Jobs/order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateOrder(_response));
        });
    }

    protected processUpdateOrder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateContactVisibility(model: UpdateContactVisibilityModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Jobs/hideContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateContactVisibility(_response));
        });
    }

    protected processUpdateContactVisibility(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    assignQuarry(clientId: string, jobId: string, model: UpdateJobDriverModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Jobs/jobDriver/{clientId}/{jobId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAssignQuarry(_response));
        });
    }

    protected processAssignQuarry(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    assignQuarries(clientId: string, jobId: string, models: CreateOrUpdateJobDriverModel[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Jobs/jobDrivers/{clientId}/{jobId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAssignQuarries(_response));
        });
    }

    protected processAssignQuarries(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addDriverNote(model: UpdateDriverNotesModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Jobs/notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddDriverNote(_response));
        });
    }

    protected processAddDriverNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    assignDriver(model: AssignDriverModel, cancelToken?: CancelToken): Promise<SingleResponseOfGuid> {
        let url_ = this.baseUrl + "/api/Jobs/assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAssignDriver(_response));
        });
    }

    protected processAssignDriver(response: AxiosResponse): Promise<SingleResponseOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfGuid.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfGuid>(null as any);
    }

    unassignDriver(model: AssignDriverModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Jobs/unassign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnassignDriver(_response));
        });
    }

    protected processUnassignDriver(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createOrUpateJobWithAssignments(clientId: string, model: CreateOrUpdateJobModel, cancelToken?: CancelToken): Promise<SingleResponseOfJobModel> {
        let url_ = this.baseUrl + "/api/Jobs/create/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateOrUpateJobWithAssignments(_response));
        });
    }

    protected processCreateOrUpateJobWithAssignments(response: AxiosResponse): Promise<SingleResponseOfJobModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfJobModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfJobModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfJobModel>(null as any);
    }

    addJob(clientId: string, model: UpdateJobModel, cancelToken?: CancelToken): Promise<SingleResponseOfJobModel> {
        let url_ = this.baseUrl + "/api/Jobs/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddJob(_response));
        });
    }

    protected processAddJob(response: AxiosResponse): Promise<SingleResponseOfJobModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfJobModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfJobModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfJobModel>(null as any);
    }

    updateJob(clientId: string, jobId: string, model: UpdateJobModel, cancelToken?: CancelToken): Promise<SingleResponseOfJobModel> {
        let url_ = this.baseUrl + "/api/Jobs/{clientId}/{jobId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateJob(_response));
        });
    }

    protected processUpdateJob(response: AxiosResponse): Promise<SingleResponseOfJobModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfJobModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfJobModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfJobModel>(null as any);
    }

    getJobImage(jobImageId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Jobs/image/{jobImageId}";
        if (jobImageId === undefined || jobImageId === null)
            throw new Error("The parameter 'jobImageId' must be defined.");
        url_ = url_.replace("{jobImageId}", encodeURIComponent("" + jobImageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetJobImage(_response));
        });
    }

    protected processGetJobImage(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteJobImage(jobImageId: string, jobId: string | undefined, cancelToken?: CancelToken): Promise<SingleResponseOfJobImageModel> {
        let url_ = this.baseUrl + "/api/Jobs/image/{jobImageId}?";
        if (jobImageId === undefined || jobImageId === null)
            throw new Error("The parameter 'jobImageId' must be defined.");
        url_ = url_.replace("{jobImageId}", encodeURIComponent("" + jobImageId));
        if (jobId === null)
            throw new Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteJobImage(_response));
        });
    }

    protected processDeleteJobImage(response: AxiosResponse): Promise<SingleResponseOfJobImageModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfJobImageModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfJobImageModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfJobImageModel>(null as any);
    }

    uploadJobImage(model: UploadJobImageModel, cancelToken?: CancelToken): Promise<SingleResponseOfJobImageModel> {
        let url_ = this.baseUrl + "/api/Jobs/image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUploadJobImage(_response));
        });
    }

    protected processUploadJobImage(response: AxiosResponse): Promise<SingleResponseOfJobImageModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfJobImageModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfJobImageModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfJobImageModel>(null as any);
    }

    updateDelivery(clientId: string, jobId: string, model: UpdateDeliveryDetailsModel, cancelToken?: CancelToken): Promise<SingleResponseOfJobModel> {
        let url_ = this.baseUrl + "/api/Jobs/deliveryDetails/{clientId}/{jobId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateDelivery(_response));
        });
    }

    protected processUpdateDelivery(response: AxiosResponse): Promise<SingleResponseOfJobModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfJobModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfJobModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfJobModel>(null as any);
    }

    moveJob(clientId: string, jobId: string, model: MoveJobModel, cancelToken?: CancelToken): Promise<SingleResponseOfJobModel> {
        let url_ = this.baseUrl + "/api/Jobs/moveJob/{clientId}/{jobId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processMoveJob(_response));
        });
    }

    protected processMoveJob(response: AxiosResponse): Promise<SingleResponseOfJobModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfJobModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfJobModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfJobModel>(null as any);
    }
}

export class JobSiteClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    getJobsiteById(jobSiteId: string, cancelToken?: CancelToken): Promise<SingleResponseOfJobSiteModel> {
        let url_ = this.baseUrl + "/api/JobSite/{jobSiteId}";
        if (jobSiteId === undefined || jobSiteId === null)
            throw new Error("The parameter 'jobSiteId' must be defined.");
        url_ = url_.replace("{jobSiteId}", encodeURIComponent("" + jobSiteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetJobsiteById(_response));
        });
    }

    protected processGetJobsiteById(response: AxiosResponse): Promise<SingleResponseOfJobSiteModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfJobSiteModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfJobSiteModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfJobSiteModel>(null as any);
    }

    createJobsite(clientId: string, customerId: string, model: UpdateJobSiteModel, cancelToken?: CancelToken): Promise<SingleResponseOfJobSiteModel> {
        let url_ = this.baseUrl + "/api/JobSite/{clientId}/{customerId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateJobsite(_response));
        });
    }

    protected processCreateJobsite(response: AxiosResponse): Promise<SingleResponseOfJobSiteModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfJobSiteModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfJobSiteModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfJobSiteModel>(null as any);
    }

    updateJobsite(clientId: string, customerId: string, jobsiteId: string, model: UpdateJobSiteModel, cancelToken?: CancelToken): Promise<SingleResponseOfJobSiteModel> {
        let url_ = this.baseUrl + "/api/JobSite/{clientId}/{customerId}/{jobsiteId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (jobsiteId === undefined || jobsiteId === null)
            throw new Error("The parameter 'jobsiteId' must be defined.");
        url_ = url_.replace("{jobsiteId}", encodeURIComponent("" + jobsiteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateJobsite(_response));
        });
    }

    protected processUpdateJobsite(response: AxiosResponse): Promise<SingleResponseOfJobSiteModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfJobSiteModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfJobSiteModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfJobSiteModel>(null as any);
    }

    deleteJobsite(clientId: string, customerId: string, jobsiteId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/JobSite/{clientId}/{customerId}/{jobsiteId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (jobsiteId === undefined || jobsiteId === null)
            throw new Error("The parameter 'jobsiteId' must be defined.");
        url_ = url_.replace("{jobsiteId}", encodeURIComponent("" + jobsiteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteJobsite(_response));
        });
    }

    protected processDeleteJobsite(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MaterialsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    listForClient(clientId: string | undefined, cancelToken?: CancelToken): Promise<ListResponseOfMaterialModel> {
        let url_ = this.baseUrl + "/api/Materials/list?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListForClient(_response));
        });
    }

    protected processListForClient(response: AxiosResponse): Promise<ListResponseOfMaterialModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfMaterialModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfMaterialModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfMaterialModel>(null as any);
    }

    create(clientId: string | undefined, model: CreateMaterial, cancelToken?: CancelToken): Promise<SingleResponseOfMaterialModel> {
        let url_ = this.baseUrl + "/api/Materials?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<SingleResponseOfMaterialModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfMaterialModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfMaterialModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfMaterialModel>(null as any);
    }

    update(clientId: string | undefined, materialId: string, model: MaterialModel, cancelToken?: CancelToken): Promise<SingleResponseOfMaterialModel> {
        let url_ = this.baseUrl + "/api/Materials/{materialId}?";
        if (materialId === undefined || materialId === null)
            throw new Error("The parameter 'materialId' must be defined.");
        url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<SingleResponseOfMaterialModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfMaterialModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfMaterialModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfMaterialModel>(null as any);
    }

    delete(clientId: string | undefined, materialId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Materials/{materialId}?";
        if (materialId === undefined || materialId === null)
            throw new Error("The parameter 'materialId' must be defined.");
        url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NotificationsClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    updateInstallation(deviceInstallation: DeviceInstallation, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Notifications/installations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceInstallation);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateInstallation(_response));
        });
    }

    protected processUpdateInstallation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteInstallation(installationId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Notifications/installations/{installationId}";
        if (installationId === undefined || installationId === null)
            throw new Error("The parameter 'installationId' must be defined.");
        url_ = url_.replace("{installationId}", encodeURIComponent("" + installationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteInstallation(_response));
        });
    }

    protected processDeleteInstallation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    requestPush(notificationRequest: NotificationRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Notifications/requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRequestPush(_response));
        });
    }

    protected processRequestPush(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class QuantitiesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    listForClient(clientId: string | undefined, cancelToken?: CancelToken): Promise<ListResponseOfQuantityModel> {
        let url_ = this.baseUrl + "/api/Quantities/list?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListForClient(_response));
        });
    }

    protected processListForClient(response: AxiosResponse): Promise<ListResponseOfQuantityModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfQuantityModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfQuantityModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfQuantityModel>(null as any);
    }

    create(clientId: string | undefined, model: CreateQuantity, cancelToken?: CancelToken): Promise<SingleResponseOfQuantityModel> {
        let url_ = this.baseUrl + "/api/Quantities?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<SingleResponseOfQuantityModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfQuantityModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfQuantityModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfQuantityModel>(null as any);
    }

    update(clientId: string | undefined, quantityId: string, model: QuantityModel, cancelToken?: CancelToken): Promise<SingleResponseOfQuantityModel> {
        let url_ = this.baseUrl + "/api/Quantities/{quantityId}?";
        if (quantityId === undefined || quantityId === null)
            throw new Error("The parameter 'quantityId' must be defined.");
        url_ = url_.replace("{quantityId}", encodeURIComponent("" + quantityId));
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<SingleResponseOfQuantityModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfQuantityModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfQuantityModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfQuantityModel>(null as any);
    }

    delete(clientId: string | undefined, quantityId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Quantities/{quantityId}?";
        if (quantityId === undefined || quantityId === null)
            throw new Error("The parameter 'quantityId' must be defined.");
        url_ = url_.replace("{quantityId}", encodeURIComponent("" + quantityId));
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class QuarriesClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    listForClient(clientId: string | undefined, cancelToken?: CancelToken): Promise<ListResponseOfQuarryModel> {
        let url_ = this.baseUrl + "/api/Quarries/list?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processListForClient(_response));
        });
    }

    protected processListForClient(response: AxiosResponse): Promise<ListResponseOfQuarryModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfQuarryModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfQuarryModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfQuarryModel>(null as any);
    }

    create(clientId: string | undefined, model: CreateQuarry, cancelToken?: CancelToken): Promise<SingleResponseOfQuarryModel> {
        let url_ = this.baseUrl + "/api/Quarries?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<SingleResponseOfQuarryModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfQuarryModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfQuarryModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfQuarryModel>(null as any);
    }

    update(clientId: string | undefined, quarryId: string, model: QuarryModel, cancelToken?: CancelToken): Promise<SingleResponseOfQuarryModel> {
        let url_ = this.baseUrl + "/api/Quarries/{quarryId}?";
        if (quarryId === undefined || quarryId === null)
            throw new Error("The parameter 'quarryId' must be defined.");
        url_ = url_.replace("{quarryId}", encodeURIComponent("" + quarryId));
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<SingleResponseOfQuarryModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfQuarryModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfQuarryModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfQuarryModel>(null as any);
    }

    delete(clientId: string | undefined, quarryId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Quarries/{quarryId}?";
        if (quarryId === undefined || quarryId === null)
            throw new Error("The parameter 'quarryId' must be defined.");
        url_ = url_.replace("{quarryId}", encodeURIComponent("" + quarryId));
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserClient extends AxiosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("https://localhost:7096");

    }

    list(filterSort: UserFilterSort, cancelToken?: CancelToken): Promise<ListResponseOfUserModel> {
        let url_ = this.baseUrl + "/api/User/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterSort);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processList(_response));
        });
    }

    protected processList(response: AxiosResponse): Promise<ListResponseOfUserModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResponseOfUserModel.fromJS(resultData200);
            return Promise.resolve<ListResponseOfUserModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResponseOfUserModel>(null as any);
    }

    create(clientId: string | undefined, model: CreateUser, cancelToken?: CancelToken): Promise<SingleResponseOfUserModel> {
        let url_ = this.baseUrl + "/api/User?";
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<SingleResponseOfUserModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfUserModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfUserModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfUserModel>(null as any);
    }

    update(clientId: string | undefined, userId: string, model: UpdateUser, cancelToken?: CancelToken): Promise<SingleResponseOfUserModel> {
        let url_ = this.baseUrl + "/api/User/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<SingleResponseOfUserModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SingleResponseOfUserModel.fromJS(resultData200);
            return Promise.resolve<SingleResponseOfUserModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SingleResponseOfUserModel>(null as any);
    }

    delete(clientId: string | undefined, userId: string, cancelToken?: CancelToken): Promise<Response> {
        let url_ = this.baseUrl + "/api/User/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }
}

export class ListResponseOfApplicationModel implements IListResponseOfApplicationModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: ApplicationModel[];
    totalItems?: number | undefined;

    constructor(data?: IListResponseOfApplicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["model"])) {
                this.model = [] as any;
                for (let item of _data["model"])
                    this.model!.push(ApplicationModel.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): ListResponseOfApplicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfApplicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.model)) {
            data["model"] = [];
            for (let item of this.model)
                data["model"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IListResponseOfApplicationModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: ApplicationModel[];
    totalItems?: number | undefined;
}

export class ApplicationModel implements IApplicationModel {
    applicationId!: string;
    clientId!: string;
    name?: string | undefined;
    index!: number;

    constructor(data?: IApplicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): ApplicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["index"] = this.index;
        return data;
    }
}

export interface IApplicationModel {
    applicationId: string;
    clientId: string;
    name?: string | undefined;
    index: number;
}

export class SingleResponseOfApplicationModel implements ISingleResponseOfApplicationModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model?: ApplicationModel | undefined;

    constructor(data?: ISingleResponseOfApplicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? ApplicationModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleResponseOfApplicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfApplicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfApplicationModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model?: ApplicationModel | undefined;
}

export class CreateApplication implements ICreateApplication {
    name!: string;
    index!: number;

    constructor(data?: ICreateApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): CreateApplication {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["index"] = this.index;
        return data;
    }
}

export interface ICreateApplication {
    name: string;
    index: number;
}

export class SingleResponseOfAuthResponse implements ISingleResponseOfAuthResponse {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model?: AuthResponse | undefined;

    constructor(data?: ISingleResponseOfAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? AuthResponse.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleResponseOfAuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfAuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfAuthResponse {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model?: AuthResponse | undefined;
}

export class AuthResponse implements IAuthResponse {
    accessToken!: string;
    expiresIn!: number;
    tokenType!: string;
    refreshToken!: string;
    email!: string;
    firstName!: string;
    lastName!: string;
    userRole!: UserRole;
    id!: string;
    clientId!: string;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.expiresIn = _data["expiresIn"];
            this.tokenType = _data["tokenType"];
            this.refreshToken = _data["refreshToken"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userRole = _data["userRole"];
            this.id = _data["id"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["expiresIn"] = this.expiresIn;
        data["tokenType"] = this.tokenType;
        data["refreshToken"] = this.refreshToken;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userRole"] = this.userRole;
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IAuthResponse {
    accessToken: string;
    expiresIn: number;
    tokenType: string;
    refreshToken: string;
    email: string;
    firstName: string;
    lastName: string;
    userRole: UserRole;
    id: string;
    clientId: string;
}

export enum UserRole {
    SystemUser = "SystemUser",
    Dispatcher = "Dispatcher",
    Driver = "Driver",
    Administrator = "Administrator",
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class AuthRequest implements IAuthRequest {
    username!: string;
    password!: string;

    constructor(data?: IAuthRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthRequest {
    username: string;
    password: string;
}

export class ImpersonationRequest implements IImpersonationRequest {
    clientId!: string;

    constructor(data?: IImpersonationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ImpersonationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IImpersonationRequest {
    clientId: string;
}

export class RefreshRequest implements IRefreshRequest {
    refreshToken!: string;
    clientId!: string;

    constructor(data?: IRefreshRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): RefreshRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IRefreshRequest {
    refreshToken: string;
    clientId: string;
}

export class Response implements IResponse {
    message!: string;
    hasError!: boolean;
    errorMessage!: string;
    errorCode?: number | undefined;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.hasError = _data["hasError"];
            this.errorMessage = _data["errorMessage"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["hasError"] = this.hasError;
        data["errorMessage"] = this.errorMessage;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IResponse {
    message: string;
    hasError: boolean;
    errorMessage: string;
    errorCode?: number | undefined;
}

export class SingleResponseOfBoolean implements ISingleResponseOfBoolean {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: boolean;

    constructor(data?: ISingleResponseOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): SingleResponseOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model;
        return data;
    }
}

export interface ISingleResponseOfBoolean {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: boolean;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    email!: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IForgotPasswordRequest {
    email: string;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    email!: string;
    token!: string;
    newPassword!: string;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.token = _data["token"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IResetPasswordRequest {
    email: string;
    token: string;
    newPassword: string;
}

export class SingleResponseOfClientModel implements ISingleResponseOfClientModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model?: ClientModel | undefined;

    constructor(data?: ISingleResponseOfClientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? ClientModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleResponseOfClientModel {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfClientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfClientModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model?: ClientModel | undefined;
}

export class ClientModel implements IClientModel {
    clientId!: string;
    name?: string | undefined;
    mainThemeColor?: string | undefined;
    mainThemeTextColor?: string | undefined;
    workingDays?: DaysOfWeek[] | undefined;
    jobSchedulerTimeIntervals?: number | undefined;
    companyLogoUrl?: string | undefined;

    constructor(data?: IClientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.mainThemeColor = _data["mainThemeColor"];
            this.mainThemeTextColor = _data["mainThemeTextColor"];
            if (Array.isArray(_data["workingDays"])) {
                this.workingDays = [] as any;
                for (let item of _data["workingDays"])
                    this.workingDays!.push(item);
            }
            this.jobSchedulerTimeIntervals = _data["jobSchedulerTimeIntervals"];
            this.companyLogoUrl = _data["companyLogoUrl"];
        }
    }

    static fromJS(data: any): ClientModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["mainThemeColor"] = this.mainThemeColor;
        data["mainThemeTextColor"] = this.mainThemeTextColor;
        if (Array.isArray(this.workingDays)) {
            data["workingDays"] = [];
            for (let item of this.workingDays)
                data["workingDays"].push(item);
        }
        data["jobSchedulerTimeIntervals"] = this.jobSchedulerTimeIntervals;
        data["companyLogoUrl"] = this.companyLogoUrl;
        return data;
    }
}

export interface IClientModel {
    clientId: string;
    name?: string | undefined;
    mainThemeColor?: string | undefined;
    mainThemeTextColor?: string | undefined;
    workingDays?: DaysOfWeek[] | undefined;
    jobSchedulerTimeIntervals?: number | undefined;
    companyLogoUrl?: string | undefined;
}

export enum DaysOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export class ListResponseOfClientModel implements IListResponseOfClientModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: ClientModel[];
    totalItems?: number | undefined;

    constructor(data?: IListResponseOfClientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["model"])) {
                this.model = [] as any;
                for (let item of _data["model"])
                    this.model!.push(ClientModel.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): ListResponseOfClientModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfClientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.model)) {
            data["model"] = [];
            for (let item of this.model)
                data["model"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IListResponseOfClientModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: ClientModel[];
    totalItems?: number | undefined;
}

export class SingleResponseOfContactModel implements ISingleResponseOfContactModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model?: ContactModel | undefined;

    constructor(data?: ISingleResponseOfContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? ContactModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleResponseOfContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfContactModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model?: ContactModel | undefined;
}

export class ContactModel implements IContactModel {
    contactId!: string;
    email?: string | undefined;
    name?: string | undefined;
    ext?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.ext = _data["ext"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): ContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["email"] = this.email;
        data["name"] = this.name;
        data["ext"] = this.ext;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IContactModel {
    contactId: string;
    email?: string | undefined;
    name?: string | undefined;
    ext?: string | undefined;
    phone?: string | undefined;
}

export class UpdateContactModel implements IUpdateContactModel {
    email?: string | undefined;
    name?: string | undefined;
    ext?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IUpdateContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
            this.ext = _data["ext"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): UpdateContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        data["ext"] = this.ext;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IUpdateContactModel {
    email?: string | undefined;
    name?: string | undefined;
    ext?: string | undefined;
    phone?: string | undefined;
}

export class ListResponseOfCustomerModel implements IListResponseOfCustomerModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: CustomerModel[];
    totalItems?: number | undefined;

    constructor(data?: IListResponseOfCustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["model"])) {
                this.model = [] as any;
                for (let item of _data["model"])
                    this.model!.push(CustomerModel.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): ListResponseOfCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfCustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.model)) {
            data["model"] = [];
            for (let item of this.model)
                data["model"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IListResponseOfCustomerModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: CustomerModel[];
    totalItems?: number | undefined;
}

export class CustomerModel implements ICustomerModel {
    customerId!: string;
    name!: string;
    phone?: string | undefined;
    ext?: string | undefined;
    email?: string | undefined;
    businessAddress?: string | undefined;
    notes?: string | undefined;
    isCOD!: boolean;
    lastUsedTimestamp?: Date | undefined;

    constructor(data?: ICustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.ext = _data["ext"];
            this.email = _data["email"];
            this.businessAddress = _data["businessAddress"];
            this.notes = _data["notes"];
            this.isCOD = _data["isCOD"];
            this.lastUsedTimestamp = _data["lastUsedTimestamp"] ? new Date(_data["lastUsedTimestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["ext"] = this.ext;
        data["email"] = this.email;
        data["businessAddress"] = this.businessAddress;
        data["notes"] = this.notes;
        data["isCOD"] = this.isCOD;
        data["lastUsedTimestamp"] = this.lastUsedTimestamp ? this.lastUsedTimestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomerModel {
    customerId: string;
    name: string;
    phone?: string | undefined;
    ext?: string | undefined;
    email?: string | undefined;
    businessAddress?: string | undefined;
    notes?: string | undefined;
    isCOD: boolean;
    lastUsedTimestamp?: Date | undefined;
}

export class CustomerFilterSort implements ICustomerFilterSort {
    sortField!: CustomerSortField;
    sortDescending!: boolean;
    clientId!: string;

    constructor(data?: ICustomerFilterSort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): CustomerFilterSort {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFilterSort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface ICustomerFilterSort {
    sortField: CustomerSortField;
    sortDescending: boolean;
    clientId: string;
}

export enum CustomerSortField {
    Name = "Name",
    LastUsedTimestamp = "LastUsedTimestamp",
}

export class ListResponseOfJobSiteModel implements IListResponseOfJobSiteModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: JobSiteModel[];
    totalItems?: number | undefined;

    constructor(data?: IListResponseOfJobSiteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["model"])) {
                this.model = [] as any;
                for (let item of _data["model"])
                    this.model!.push(JobSiteModel.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): ListResponseOfJobSiteModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfJobSiteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.model)) {
            data["model"] = [];
            for (let item of this.model)
                data["model"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IListResponseOfJobSiteModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: JobSiteModel[];
    totalItems?: number | undefined;
}

export class JobSiteModel implements IJobSiteModel {
    jobSiteId!: string;
    name?: string | undefined;
    streetAddress?: string | undefined;
    cityAddress?: string | undefined;
    googleAddress?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    locationType!: LocationType;
    notes?: string | undefined;
    lastUsedTimestamp!: Date;

    constructor(data?: IJobSiteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSiteId = _data["jobSiteId"];
            this.name = _data["name"];
            this.streetAddress = _data["streetAddress"];
            this.cityAddress = _data["cityAddress"];
            this.googleAddress = _data["googleAddress"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.locationType = _data["locationType"];
            this.notes = _data["notes"];
            this.lastUsedTimestamp = _data["lastUsedTimestamp"] ? new Date(_data["lastUsedTimestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JobSiteModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobSiteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSiteId"] = this.jobSiteId;
        data["name"] = this.name;
        data["streetAddress"] = this.streetAddress;
        data["cityAddress"] = this.cityAddress;
        data["googleAddress"] = this.googleAddress;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["locationType"] = this.locationType;
        data["notes"] = this.notes;
        data["lastUsedTimestamp"] = this.lastUsedTimestamp ? this.lastUsedTimestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IJobSiteModel {
    jobSiteId: string;
    name?: string | undefined;
    streetAddress?: string | undefined;
    cityAddress?: string | undefined;
    googleAddress?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    locationType: LocationType;
    notes?: string | undefined;
    lastUsedTimestamp: Date;
}

export enum LocationType {
    Address = "Address",
    Google = "Google",
    Coordinates = "Coordinates",
}

export class JobSiteFilterSort implements IJobSiteFilterSort {
    sortField!: JobSiteSortField;
    sortDescending!: boolean;
    clientId!: string;
    customerId!: string;

    constructor(data?: IJobSiteFilterSort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.clientId = _data["clientId"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): JobSiteFilterSort {
        data = typeof data === 'object' ? data : {};
        let result = new JobSiteFilterSort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["clientId"] = this.clientId;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IJobSiteFilterSort {
    sortField: JobSiteSortField;
    sortDescending: boolean;
    clientId: string;
    customerId: string;
}

export enum JobSiteSortField {
    Name = "Name",
    LastUsedTimestamp = "LastUsedTimestamp",
}

export class ListResponseOfContactModel implements IListResponseOfContactModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: ContactModel[];
    totalItems?: number | undefined;

    constructor(data?: IListResponseOfContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["model"])) {
                this.model = [] as any;
                for (let item of _data["model"])
                    this.model!.push(ContactModel.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): ListResponseOfContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.model)) {
            data["model"] = [];
            for (let item of this.model)
                data["model"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IListResponseOfContactModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: ContactModel[];
    totalItems?: number | undefined;
}

export class SingleResponseOfCustomerModel implements ISingleResponseOfCustomerModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model?: CustomerModel | undefined;

    constructor(data?: ISingleResponseOfCustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? CustomerModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleResponseOfCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfCustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfCustomerModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model?: CustomerModel | undefined;
}

export class UpdateCustomerModel implements IUpdateCustomerModel {
    name!: string;
    phone?: string | undefined;
    ext?: string | undefined;
    email?: string | undefined;
    businessAddress?: string | undefined;
    notes?: string | undefined;
    isCOD!: boolean;
    lastUsedTimestamp?: Date | undefined;

    constructor(data?: IUpdateCustomerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.ext = _data["ext"];
            this.email = _data["email"];
            this.businessAddress = _data["businessAddress"];
            this.notes = _data["notes"];
            this.isCOD = _data["isCOD"];
            this.lastUsedTimestamp = _data["lastUsedTimestamp"] ? new Date(_data["lastUsedTimestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["ext"] = this.ext;
        data["email"] = this.email;
        data["businessAddress"] = this.businessAddress;
        data["notes"] = this.notes;
        data["isCOD"] = this.isCOD;
        data["lastUsedTimestamp"] = this.lastUsedTimestamp ? this.lastUsedTimestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateCustomerModel {
    name: string;
    phone?: string | undefined;
    ext?: string | undefined;
    email?: string | undefined;
    businessAddress?: string | undefined;
    notes?: string | undefined;
    isCOD: boolean;
    lastUsedTimestamp?: Date | undefined;
}

export class ListResponseOfDriverModel implements IListResponseOfDriverModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: DriverModel[];
    totalItems?: number | undefined;

    constructor(data?: IListResponseOfDriverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["model"])) {
                this.model = [] as any;
                for (let item of _data["model"])
                    this.model!.push(DriverModel.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): ListResponseOfDriverModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfDriverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.model)) {
            data["model"] = [];
            for (let item of this.model)
                data["model"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IListResponseOfDriverModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: DriverModel[];
    totalItems?: number | undefined;
}

export class DriverModel implements IDriverModel {
    driverId!: string;
    firstName!: string;
    lastName!: string;
    userId?: string | undefined;

    constructor(data?: IDriverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driverId = _data["driverId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): DriverModel {
        data = typeof data === 'object' ? data : {};
        let result = new DriverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driverId"] = this.driverId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IDriverModel {
    driverId: string;
    firstName: string;
    lastName: string;
    userId?: string | undefined;
}

export class SingleResponseOfDriverModel implements ISingleResponseOfDriverModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: DriverModel;

    constructor(data?: ISingleResponseOfDriverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = new DriverModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? DriverModel.fromJS(_data["model"]) : new DriverModel();
        }
    }

    static fromJS(data: any): SingleResponseOfDriverModel {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfDriverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfDriverModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: DriverModel;
}

export class JobDriverStatusModel implements IJobDriverStatusModel {
    clientId!: string;
    jobDriverId!: string;
    jobId!: string;
    status!: JobDriverStatus;

    constructor(data?: IJobDriverStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.jobDriverId = _data["jobDriverId"];
            this.jobId = _data["jobId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): JobDriverStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobDriverStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["jobDriverId"] = this.jobDriverId;
        data["jobId"] = this.jobId;
        data["status"] = this.status;
        return data;
    }
}

export interface IJobDriverStatusModel {
    clientId: string;
    jobDriverId: string;
    jobId: string;
    status: JobDriverStatus;
}

export enum JobDriverStatus {
    Sent = "Sent",
    Received = "Received",
    Read = "Read",
    Completed = "Completed",
}

export class ListResponseOfJobModel implements IListResponseOfJobModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: JobModel[];
    totalItems?: number | undefined;

    constructor(data?: IListResponseOfJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["model"])) {
                this.model = [] as any;
                for (let item of _data["model"])
                    this.model!.push(JobModel.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): ListResponseOfJobModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfJobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.model)) {
            data["model"] = [];
            for (let item of this.model)
                data["model"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IListResponseOfJobModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: JobModel[];
    totalItems?: number | undefined;
}

export class JobModel implements IJobModel {
    jobId!: string;
    material?: JobMaterialModel | undefined;
    quantity?: JobQuantityModel | undefined;
    quantityType?: QuantityType | undefined;
    customer?: CustomerModel | undefined;
    jobSite?: JobSiteModel | undefined;
    canceled!: boolean;
    completed!: boolean;
    jobSiteDetails?: JobSiteDetailsModel | undefined;
    customerContact?: ContactModel | undefined;
    applications!: JobApplicationModel[];
    driverNotes!: DriverNoteModel[];
    drivers!: JobDriverModel[];
    driverIds!: string[];
    hourly!: boolean;
    jobType!: JobType;
    createdBy!: string;
    deliveryDetails?: DeliveryDetailsModel | undefined;
    created?: Date | undefined;
    isPhoneHiddenToDriver?: boolean | undefined;
    dateOffsetString?: string | undefined;
    jobImages!: JobImageModel[];
    sortIndex!: number;

    constructor(data?: IJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applications = [];
            this.driverNotes = [];
            this.drivers = [];
            this.driverIds = [];
            this.jobImages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.material = _data["material"] ? JobMaterialModel.fromJS(_data["material"]) : <any>undefined;
            this.quantity = _data["quantity"] ? JobQuantityModel.fromJS(_data["quantity"]) : <any>undefined;
            this.quantityType = _data["quantityType"];
            this.customer = _data["customer"] ? CustomerModel.fromJS(_data["customer"]) : <any>undefined;
            this.jobSite = _data["jobSite"] ? JobSiteModel.fromJS(_data["jobSite"]) : <any>undefined;
            this.canceled = _data["canceled"];
            this.completed = _data["completed"];
            this.jobSiteDetails = _data["jobSiteDetails"] ? JobSiteDetailsModel.fromJS(_data["jobSiteDetails"]) : <any>undefined;
            this.customerContact = _data["customerContact"] ? ContactModel.fromJS(_data["customerContact"]) : <any>undefined;
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(JobApplicationModel.fromJS(item));
            }
            if (Array.isArray(_data["driverNotes"])) {
                this.driverNotes = [] as any;
                for (let item of _data["driverNotes"])
                    this.driverNotes!.push(DriverNoteModel.fromJS(item));
            }
            if (Array.isArray(_data["drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["drivers"])
                    this.drivers!.push(JobDriverModel.fromJS(item));
            }
            if (Array.isArray(_data["driverIds"])) {
                this.driverIds = [] as any;
                for (let item of _data["driverIds"])
                    this.driverIds!.push(item);
            }
            this.hourly = _data["hourly"];
            this.jobType = _data["jobType"];
            this.createdBy = _data["createdBy"];
            this.deliveryDetails = _data["deliveryDetails"] ? DeliveryDetailsModel.fromJS(_data["deliveryDetails"]) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.isPhoneHiddenToDriver = _data["isPhoneHiddenToDriver"];
            this.dateOffsetString = _data["dateOffsetString"];
            if (Array.isArray(_data["jobImages"])) {
                this.jobImages = [] as any;
                for (let item of _data["jobImages"])
                    this.jobImages!.push(JobImageModel.fromJS(item));
            }
            this.sortIndex = _data["sortIndex"];
        }
    }

    static fromJS(data: any): JobModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        data["quantity"] = this.quantity ? this.quantity.toJSON() : <any>undefined;
        data["quantityType"] = this.quantityType;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["jobSite"] = this.jobSite ? this.jobSite.toJSON() : <any>undefined;
        data["canceled"] = this.canceled;
        data["completed"] = this.completed;
        data["jobSiteDetails"] = this.jobSiteDetails ? this.jobSiteDetails.toJSON() : <any>undefined;
        data["customerContact"] = this.customerContact ? this.customerContact.toJSON() : <any>undefined;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        if (Array.isArray(this.driverNotes)) {
            data["driverNotes"] = [];
            for (let item of this.driverNotes)
                data["driverNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.drivers)) {
            data["drivers"] = [];
            for (let item of this.drivers)
                data["drivers"].push(item.toJSON());
        }
        if (Array.isArray(this.driverIds)) {
            data["driverIds"] = [];
            for (let item of this.driverIds)
                data["driverIds"].push(item);
        }
        data["hourly"] = this.hourly;
        data["jobType"] = this.jobType;
        data["createdBy"] = this.createdBy;
        data["deliveryDetails"] = this.deliveryDetails ? this.deliveryDetails.toJSON() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["isPhoneHiddenToDriver"] = this.isPhoneHiddenToDriver;
        data["dateOffsetString"] = this.dateOffsetString;
        if (Array.isArray(this.jobImages)) {
            data["jobImages"] = [];
            for (let item of this.jobImages)
                data["jobImages"].push(item.toJSON());
        }
        data["sortIndex"] = this.sortIndex;
        return data;
    }
}

export interface IJobModel {
    jobId: string;
    material?: JobMaterialModel | undefined;
    quantity?: JobQuantityModel | undefined;
    quantityType?: QuantityType | undefined;
    customer?: CustomerModel | undefined;
    jobSite?: JobSiteModel | undefined;
    canceled: boolean;
    completed: boolean;
    jobSiteDetails?: JobSiteDetailsModel | undefined;
    customerContact?: ContactModel | undefined;
    applications: JobApplicationModel[];
    driverNotes: DriverNoteModel[];
    drivers: JobDriverModel[];
    driverIds: string[];
    hourly: boolean;
    jobType: JobType;
    createdBy: string;
    deliveryDetails?: DeliveryDetailsModel | undefined;
    created?: Date | undefined;
    isPhoneHiddenToDriver?: boolean | undefined;
    dateOffsetString?: string | undefined;
    jobImages: JobImageModel[];
    sortIndex: number;
}

export class JobMaterialModel implements IJobMaterialModel {
    jobMaterialId!: string;
    material?: MaterialModel | undefined;
    customName?: string | undefined;

    constructor(data?: IJobMaterialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobMaterialId = _data["jobMaterialId"];
            this.material = _data["material"] ? MaterialModel.fromJS(_data["material"]) : <any>undefined;
            this.customName = _data["customName"];
        }
    }

    static fromJS(data: any): JobMaterialModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobMaterialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobMaterialId"] = this.jobMaterialId;
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        data["customName"] = this.customName;
        return data;
    }
}

export interface IJobMaterialModel {
    jobMaterialId: string;
    material?: MaterialModel | undefined;
    customName?: string | undefined;
}

export class MaterialModel implements IMaterialModel {
    materialId!: string;
    clientId!: string;
    name?: string | undefined;
    index!: number;

    constructor(data?: IMaterialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialId = _data["materialId"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): MaterialModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["index"] = this.index;
        return data;
    }
}

export interface IMaterialModel {
    materialId: string;
    clientId: string;
    name?: string | undefined;
    index: number;
}

export class JobQuantityModel implements IJobQuantityModel {
    jobQuantityId!: string;
    quantity?: QuantityModel | undefined;
    customName?: string | undefined;

    constructor(data?: IJobQuantityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobQuantityId = _data["jobQuantityId"];
            this.quantity = _data["quantity"] ? QuantityModel.fromJS(_data["quantity"]) : <any>undefined;
            this.customName = _data["customName"];
        }
    }

    static fromJS(data: any): JobQuantityModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobQuantityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobQuantityId"] = this.jobQuantityId;
        data["quantity"] = this.quantity ? this.quantity.toJSON() : <any>undefined;
        data["customName"] = this.customName;
        return data;
    }
}

export interface IJobQuantityModel {
    jobQuantityId: string;
    quantity?: QuantityModel | undefined;
    customName?: string | undefined;
}

export class QuantityModel implements IQuantityModel {
    quantityId!: string;
    clientId!: string;
    name?: string | undefined;
    index!: number;

    constructor(data?: IQuantityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantityId = _data["quantityId"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): QuantityModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuantityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantityId"] = this.quantityId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["index"] = this.index;
        return data;
    }
}

export interface IQuantityModel {
    quantityId: string;
    clientId: string;
    name?: string | undefined;
    index: number;
}

export enum QuantityType {
    Loads = "Loads",
    Tons = "Tons",
    Yards = "Yards",
}

export class JobSiteDetailsModel implements IJobSiteDetailsModel {
    jobSiteDetailsId!: string;
    lot?: string | undefined;
    unit?: string | undefined;
    block?: string | undefined;
    municipal?: string | undefined;
    po?: string | undefined;

    constructor(data?: IJobSiteDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSiteDetailsId = _data["jobSiteDetailsId"];
            this.lot = _data["lot"];
            this.unit = _data["unit"];
            this.block = _data["block"];
            this.municipal = _data["municipal"];
            this.po = _data["po"];
        }
    }

    static fromJS(data: any): JobSiteDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobSiteDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSiteDetailsId"] = this.jobSiteDetailsId;
        data["lot"] = this.lot;
        data["unit"] = this.unit;
        data["block"] = this.block;
        data["municipal"] = this.municipal;
        data["po"] = this.po;
        return data;
    }
}

export interface IJobSiteDetailsModel {
    jobSiteDetailsId: string;
    lot?: string | undefined;
    unit?: string | undefined;
    block?: string | undefined;
    municipal?: string | undefined;
    po?: string | undefined;
}

export class JobApplicationModel implements IJobApplicationModel {
    jobApplicationId!: string;
    application?: ApplicationModel | undefined;
    customName?: string | undefined;

    constructor(data?: IJobApplicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobApplicationId = _data["jobApplicationId"];
            this.application = _data["application"] ? ApplicationModel.fromJS(_data["application"]) : <any>undefined;
            this.customName = _data["customName"];
        }
    }

    static fromJS(data: any): JobApplicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobApplicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobApplicationId"] = this.jobApplicationId;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["customName"] = this.customName;
        return data;
    }
}

export interface IJobApplicationModel {
    jobApplicationId: string;
    application?: ApplicationModel | undefined;
    customName?: string | undefined;
}

export class DriverNoteModel implements IDriverNoteModel {
    driverNoteId!: string;
    driverName?: string | undefined;
    note?: string | undefined;
    timestamp!: Date;

    constructor(data?: IDriverNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driverNoteId = _data["driverNoteId"];
            this.driverName = _data["driverName"];
            this.note = _data["note"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DriverNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new DriverNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driverNoteId"] = this.driverNoteId;
        data["driverName"] = this.driverName;
        data["note"] = this.note;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDriverNoteModel {
    driverNoteId: string;
    driverName?: string | undefined;
    note?: string | undefined;
    timestamp: Date;
}

export class JobDriverModel implements IJobDriverModel {
    jobDriverId!: string;
    driverId!: string;
    firstName!: string;
    lastName!: string;
    status?: JobDriverStatus | undefined;
    userId?: string | undefined;
    quarry?: QuarryModel | undefined;

    constructor(data?: IJobDriverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobDriverId = _data["jobDriverId"];
            this.driverId = _data["driverId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.status = _data["status"];
            this.userId = _data["userId"];
            this.quarry = _data["quarry"] ? QuarryModel.fromJS(_data["quarry"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JobDriverModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobDriverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobDriverId"] = this.jobDriverId;
        data["driverId"] = this.driverId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["quarry"] = this.quarry ? this.quarry.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJobDriverModel {
    jobDriverId: string;
    driverId: string;
    firstName: string;
    lastName: string;
    status?: JobDriverStatus | undefined;
    userId?: string | undefined;
    quarry?: QuarryModel | undefined;
}

export class QuarryModel implements IQuarryModel {
    quarryId!: string;
    clientId!: string;
    name?: string | undefined;
    index!: number;
    address?: string | undefined;

    constructor(data?: IQuarryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quarryId = _data["quarryId"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.index = _data["index"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): QuarryModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuarryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quarryId"] = this.quarryId;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["index"] = this.index;
        data["address"] = this.address;
        return data;
    }
}

export interface IQuarryModel {
    quarryId: string;
    clientId: string;
    name?: string | undefined;
    index: number;
    address?: string | undefined;
}

export enum JobType {
    Sling = "Sling",
    Dump = "Dump",
    Pump = "Pump",
}

export class DeliveryDetailsModel implements IDeliveryDetailsModel {
    deliveryDetailsId!: string;
    deliveryDate?: Date | undefined;
    estimateEndDate?: Date | undefined;
    deliveryDateType!: DeliveryDateType;
    isTaxable!: boolean;
    priceType!: PriceType;
    price?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IDeliveryDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryDetailsId = _data["deliveryDetailsId"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.estimateEndDate = _data["estimateEndDate"] ? new Date(_data["estimateEndDate"].toString()) : <any>undefined;
            this.deliveryDateType = _data["deliveryDateType"];
            this.isTaxable = _data["isTaxable"];
            this.priceType = _data["priceType"];
            this.price = _data["price"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): DeliveryDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryDetailsId"] = this.deliveryDetailsId;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["estimateEndDate"] = this.estimateEndDate ? this.estimateEndDate.toISOString() : <any>undefined;
        data["deliveryDateType"] = this.deliveryDateType;
        data["isTaxable"] = this.isTaxable;
        data["priceType"] = this.priceType;
        data["price"] = this.price;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IDeliveryDetailsModel {
    deliveryDetailsId: string;
    deliveryDate?: Date | undefined;
    estimateEndDate?: Date | undefined;
    deliveryDateType: DeliveryDateType;
    isTaxable: boolean;
    priceType: PriceType;
    price?: string | undefined;
    notes?: string | undefined;
}

export enum DeliveryDateType {
    NotConfirmed = "NotConfirmed",
    WillCall = "WillCall",
    At = "At",
    Before = "Before",
    After = "After",
    Anytime = "Anytime",
    ASAP = "ASAP",
}

export enum PriceType {
    TonYard = "TonYard",
    Hour = "Hour",
    DeliveryLoad = "DeliveryLoad",
}

export class JobImageModel implements IJobImageModel {
    jobImageId!: string;
    fileName!: string;
    imageUrl!: string;

    constructor(data?: IJobImageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobImageId = _data["jobImageId"];
            this.fileName = _data["fileName"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): JobImageModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobImageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobImageId"] = this.jobImageId;
        data["fileName"] = this.fileName;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface IJobImageModel {
    jobImageId: string;
    fileName: string;
    imageUrl: string;
}

export class SingleResponseOfNullableDateTimeOffset implements ISingleResponseOfNullableDateTimeOffset {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model?: Date | undefined;

    constructor(data?: ISingleResponseOfNullableDateTimeOffset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? new Date(_data["model"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleResponseOfNullableDateTimeOffset {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfNullableDateTimeOffset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfNullableDateTimeOffset {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model?: Date | undefined;
}

export class JobsForCustomer implements IJobsForCustomer {
    clientId!: string;
    customerId!: string;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;

    constructor(data?: IJobsForCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.customerId = _data["customerId"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JobsForCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new JobsForCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["customerId"] = this.customerId;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IJobsForCustomer {
    clientId: string;
    customerId: string;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
}

export class JobsForCalendar implements IJobsForCalendar {
    clientId!: string;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;

    constructor(data?: IJobsForCalendar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JobsForCalendar {
        data = typeof data === 'object' ? data : {};
        let result = new JobsForCalendar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        return data;
    }
}

export interface IJobsForCalendar {
    clientId: string;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
}

export class JobSearchFilter implements IJobSearchFilter {
    includeCompleted!: boolean;
    includeCanceled!: boolean;
    isCompleted?: boolean | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
    customerName?: string | undefined;
    jobSite?: string | undefined;

    constructor(data?: IJobSearchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeCompleted = _data["includeCompleted"];
            this.includeCanceled = _data["includeCanceled"];
            this.isCompleted = _data["isCompleted"];
            this.dateStart = _data["dateStart"] ? new Date(_data["dateStart"].toString()) : <any>undefined;
            this.dateEnd = _data["dateEnd"] ? new Date(_data["dateEnd"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.jobSite = _data["jobSite"];
        }
    }

    static fromJS(data: any): JobSearchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new JobSearchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeCompleted"] = this.includeCompleted;
        data["includeCanceled"] = this.includeCanceled;
        data["isCompleted"] = this.isCompleted;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>undefined;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["jobSite"] = this.jobSite;
        return data;
    }
}

export interface IJobSearchFilter {
    includeCompleted: boolean;
    includeCanceled: boolean;
    isCompleted?: boolean | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
    customerName?: string | undefined;
    jobSite?: string | undefined;
}

export class CancelJobModel implements ICancelJobModel {
    clientId!: string;
    jobId!: string;
    cancelStatus!: boolean;

    constructor(data?: ICancelJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.jobId = _data["jobId"];
            this.cancelStatus = _data["cancelStatus"];
        }
    }

    static fromJS(data: any): CancelJobModel {
        data = typeof data === 'object' ? data : {};
        let result = new CancelJobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["jobId"] = this.jobId;
        data["cancelStatus"] = this.cancelStatus;
        return data;
    }
}

export interface ICancelJobModel {
    clientId: string;
    jobId: string;
    cancelStatus: boolean;
}

export class CompleteJobModel implements ICompleteJobModel {
    clientId!: string;
    jobId!: string;
    completeStatus!: boolean;
    cancelStatus!: boolean;

    constructor(data?: ICompleteJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.jobId = _data["jobId"];
            this.completeStatus = _data["completeStatus"];
            this.cancelStatus = _data["cancelStatus"];
        }
    }

    static fromJS(data: any): CompleteJobModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteJobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["jobId"] = this.jobId;
        data["completeStatus"] = this.completeStatus;
        data["cancelStatus"] = this.cancelStatus;
        return data;
    }
}

export interface ICompleteJobModel {
    clientId: string;
    jobId: string;
    completeStatus: boolean;
    cancelStatus: boolean;
}

export class UpdateOrderModel implements IUpdateOrderModel {
    clientId!: string;
    jobId!: string;
    reorderedTimeTicks!: number;

    constructor(data?: IUpdateOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.jobId = _data["jobId"];
            this.reorderedTimeTicks = _data["reorderedTimeTicks"];
        }
    }

    static fromJS(data: any): UpdateOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["jobId"] = this.jobId;
        data["reorderedTimeTicks"] = this.reorderedTimeTicks;
        return data;
    }
}

export interface IUpdateOrderModel {
    clientId: string;
    jobId: string;
    reorderedTimeTicks: number;
}

export class UpdateContactVisibilityModel implements IUpdateContactVisibilityModel {
    clientId!: string;
    jobId!: string;
    hideContact!: boolean;

    constructor(data?: IUpdateContactVisibilityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.jobId = _data["jobId"];
            this.hideContact = _data["hideContact"];
        }
    }

    static fromJS(data: any): UpdateContactVisibilityModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactVisibilityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["jobId"] = this.jobId;
        data["hideContact"] = this.hideContact;
        return data;
    }
}

export interface IUpdateContactVisibilityModel {
    clientId: string;
    jobId: string;
    hideContact: boolean;
}

export class UpdateJobDriverModel implements IUpdateJobDriverModel {
    jobDriverId!: string;
    driverId?: string | undefined;
    quarryId?: string | undefined;

    constructor(data?: IUpdateJobDriverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobDriverId = _data["jobDriverId"];
            this.driverId = _data["driverId"];
            this.quarryId = _data["quarryId"];
        }
    }

    static fromJS(data: any): UpdateJobDriverModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobDriverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobDriverId"] = this.jobDriverId;
        data["driverId"] = this.driverId;
        data["quarryId"] = this.quarryId;
        return data;
    }
}

export interface IUpdateJobDriverModel {
    jobDriverId: string;
    driverId?: string | undefined;
    quarryId?: string | undefined;
}

export class CreateOrUpdateJobDriverModel implements ICreateOrUpdateJobDriverModel {
    jobDriverId?: string | undefined;
    driverId!: string;
    quarryId?: string | undefined;

    constructor(data?: ICreateOrUpdateJobDriverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobDriverId = _data["jobDriverId"];
            this.driverId = _data["driverId"];
            this.quarryId = _data["quarryId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateJobDriverModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateJobDriverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobDriverId"] = this.jobDriverId;
        data["driverId"] = this.driverId;
        data["quarryId"] = this.quarryId;
        return data;
    }
}

export interface ICreateOrUpdateJobDriverModel {
    jobDriverId?: string | undefined;
    driverId: string;
    quarryId?: string | undefined;
}

export class UpdateDriverNotesModel implements IUpdateDriverNotesModel {
    clientId!: string;
    jobId!: string;
    driverNotes!: DriverNoteModel[];

    constructor(data?: IUpdateDriverNotesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.driverNotes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.jobId = _data["jobId"];
            if (Array.isArray(_data["driverNotes"])) {
                this.driverNotes = [] as any;
                for (let item of _data["driverNotes"])
                    this.driverNotes!.push(DriverNoteModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateDriverNotesModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDriverNotesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["jobId"] = this.jobId;
        if (Array.isArray(this.driverNotes)) {
            data["driverNotes"] = [];
            for (let item of this.driverNotes)
                data["driverNotes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateDriverNotesModel {
    clientId: string;
    jobId: string;
    driverNotes: DriverNoteModel[];
}

export class SingleResponseOfGuid implements ISingleResponseOfGuid {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: string;

    constructor(data?: ISingleResponseOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): SingleResponseOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model;
        return data;
    }
}

export interface ISingleResponseOfGuid {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: string;
}

export class AssignDriverModel implements IAssignDriverModel {
    clientId!: string;
    jobId!: string;
    driverId!: string;

    constructor(data?: IAssignDriverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.jobId = _data["jobId"];
            this.driverId = _data["driverId"];
        }
    }

    static fromJS(data: any): AssignDriverModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignDriverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["jobId"] = this.jobId;
        data["driverId"] = this.driverId;
        return data;
    }
}

export interface IAssignDriverModel {
    clientId: string;
    jobId: string;
    driverId: string;
}

export class SingleResponseOfJobModel implements ISingleResponseOfJobModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model?: JobModel | undefined;

    constructor(data?: ISingleResponseOfJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? JobModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleResponseOfJobModel {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfJobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfJobModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model?: JobModel | undefined;
}

export class CreateOrUpdateJobModel implements ICreateOrUpdateJobModel {
    jobId?: string | undefined;
    drivers!: CreateOrUpdateJobDriverModel[];
    material?: UpdateJobMaterialModel | undefined;
    quantity?: UpdateJobQuantityModel | undefined;
    quantityType?: QuantityType | undefined;
    customerId?: string | undefined;
    jobSiteId?: string | undefined;
    jobSiteDetails?: UpdateJobSiteDetailsModel | undefined;
    customerContactId?: string | undefined;
    applications!: string[];
    hourly!: boolean;
    jobType!: JobType;
    deliveryDetails?: UpdateDeliveryDetailsModel | undefined;
    isPhoneHiddenToDriver?: boolean | undefined;
    dateOffsetString?: string | undefined;
    notes?: string | undefined;
    isCompleted!: boolean;

    constructor(data?: ICreateOrUpdateJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.drivers = [];
            this.applications = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            if (Array.isArray(_data["drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["drivers"])
                    this.drivers!.push(CreateOrUpdateJobDriverModel.fromJS(item));
            }
            this.material = _data["material"] ? UpdateJobMaterialModel.fromJS(_data["material"]) : <any>undefined;
            this.quantity = _data["quantity"] ? UpdateJobQuantityModel.fromJS(_data["quantity"]) : <any>undefined;
            this.quantityType = _data["quantityType"];
            this.customerId = _data["customerId"];
            this.jobSiteId = _data["jobSiteId"];
            this.jobSiteDetails = _data["jobSiteDetails"] ? UpdateJobSiteDetailsModel.fromJS(_data["jobSiteDetails"]) : <any>undefined;
            this.customerContactId = _data["customerContactId"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(item);
            }
            this.hourly = _data["hourly"];
            this.jobType = _data["jobType"];
            this.deliveryDetails = _data["deliveryDetails"] ? UpdateDeliveryDetailsModel.fromJS(_data["deliveryDetails"]) : <any>undefined;
            this.isPhoneHiddenToDriver = _data["isPhoneHiddenToDriver"];
            this.dateOffsetString = _data["dateOffsetString"];
            this.notes = _data["notes"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): CreateOrUpdateJobModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateJobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        if (Array.isArray(this.drivers)) {
            data["drivers"] = [];
            for (let item of this.drivers)
                data["drivers"].push(item.toJSON());
        }
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        data["quantity"] = this.quantity ? this.quantity.toJSON() : <any>undefined;
        data["quantityType"] = this.quantityType;
        data["customerId"] = this.customerId;
        data["jobSiteId"] = this.jobSiteId;
        data["jobSiteDetails"] = this.jobSiteDetails ? this.jobSiteDetails.toJSON() : <any>undefined;
        data["customerContactId"] = this.customerContactId;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item);
        }
        data["hourly"] = this.hourly;
        data["jobType"] = this.jobType;
        data["deliveryDetails"] = this.deliveryDetails ? this.deliveryDetails.toJSON() : <any>undefined;
        data["isPhoneHiddenToDriver"] = this.isPhoneHiddenToDriver;
        data["dateOffsetString"] = this.dateOffsetString;
        data["notes"] = this.notes;
        data["isCompleted"] = this.isCompleted;
        return data;
    }
}

export interface ICreateOrUpdateJobModel {
    jobId?: string | undefined;
    drivers: CreateOrUpdateJobDriverModel[];
    material?: UpdateJobMaterialModel | undefined;
    quantity?: UpdateJobQuantityModel | undefined;
    quantityType?: QuantityType | undefined;
    customerId?: string | undefined;
    jobSiteId?: string | undefined;
    jobSiteDetails?: UpdateJobSiteDetailsModel | undefined;
    customerContactId?: string | undefined;
    applications: string[];
    hourly: boolean;
    jobType: JobType;
    deliveryDetails?: UpdateDeliveryDetailsModel | undefined;
    isPhoneHiddenToDriver?: boolean | undefined;
    dateOffsetString?: string | undefined;
    notes?: string | undefined;
    isCompleted: boolean;
}

export class UpdateJobMaterialModel implements IUpdateJobMaterialModel {
    jobMaterialId?: string | undefined;
    customName?: string | undefined;
    materialId?: string | undefined;

    constructor(data?: IUpdateJobMaterialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobMaterialId = _data["jobMaterialId"];
            this.customName = _data["customName"];
            this.materialId = _data["materialId"];
        }
    }

    static fromJS(data: any): UpdateJobMaterialModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobMaterialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobMaterialId"] = this.jobMaterialId;
        data["customName"] = this.customName;
        data["materialId"] = this.materialId;
        return data;
    }
}

export interface IUpdateJobMaterialModel {
    jobMaterialId?: string | undefined;
    customName?: string | undefined;
    materialId?: string | undefined;
}

export class UpdateJobQuantityModel implements IUpdateJobQuantityModel {
    jobQuantityId?: string | undefined;
    customName?: string | undefined;
    quantityId?: string | undefined;

    constructor(data?: IUpdateJobQuantityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobQuantityId = _data["jobQuantityId"];
            this.customName = _data["customName"];
            this.quantityId = _data["quantityId"];
        }
    }

    static fromJS(data: any): UpdateJobQuantityModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobQuantityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobQuantityId"] = this.jobQuantityId;
        data["customName"] = this.customName;
        data["quantityId"] = this.quantityId;
        return data;
    }
}

export interface IUpdateJobQuantityModel {
    jobQuantityId?: string | undefined;
    customName?: string | undefined;
    quantityId?: string | undefined;
}

export class UpdateJobSiteDetailsModel implements IUpdateJobSiteDetailsModel {
    lot?: string | undefined;
    unit?: string | undefined;
    block?: string | undefined;
    municipal?: string | undefined;
    po?: string | undefined;

    constructor(data?: IUpdateJobSiteDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lot = _data["lot"];
            this.unit = _data["unit"];
            this.block = _data["block"];
            this.municipal = _data["municipal"];
            this.po = _data["po"];
        }
    }

    static fromJS(data: any): UpdateJobSiteDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobSiteDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lot"] = this.lot;
        data["unit"] = this.unit;
        data["block"] = this.block;
        data["municipal"] = this.municipal;
        data["po"] = this.po;
        return data;
    }
}

export interface IUpdateJobSiteDetailsModel {
    lot?: string | undefined;
    unit?: string | undefined;
    block?: string | undefined;
    municipal?: string | undefined;
    po?: string | undefined;
}

export class UpdateDeliveryDetailsModel implements IUpdateDeliveryDetailsModel {
    deliveryDate?: Date | undefined;
    estimateEndDate?: Date | undefined;
    deliveryDateType!: DeliveryDateType;
    isTaxable!: boolean;
    priceType!: PriceType;
    price?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IUpdateDeliveryDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.estimateEndDate = _data["estimateEndDate"] ? new Date(_data["estimateEndDate"].toString()) : <any>undefined;
            this.deliveryDateType = _data["deliveryDateType"];
            this.isTaxable = _data["isTaxable"];
            this.priceType = _data["priceType"];
            this.price = _data["price"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateDeliveryDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDeliveryDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["estimateEndDate"] = this.estimateEndDate ? this.estimateEndDate.toISOString() : <any>undefined;
        data["deliveryDateType"] = this.deliveryDateType;
        data["isTaxable"] = this.isTaxable;
        data["priceType"] = this.priceType;
        data["price"] = this.price;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateDeliveryDetailsModel {
    deliveryDate?: Date | undefined;
    estimateEndDate?: Date | undefined;
    deliveryDateType: DeliveryDateType;
    isTaxable: boolean;
    priceType: PriceType;
    price?: string | undefined;
    notes?: string | undefined;
}

export class UpdateJobModel implements IUpdateJobModel {
    material?: UpdateJobMaterialModel | undefined;
    quantity?: UpdateJobQuantityModel | undefined;
    quantityType?: QuantityType | undefined;
    customerId?: string | undefined;
    jobSiteId?: string | undefined;
    jobSiteDetails?: UpdateJobSiteDetailsModel | undefined;
    customerContactId?: string | undefined;
    applications!: UpdateJobApplicationModel[];
    hourly!: boolean;
    jobType!: JobType;
    deliveryDetails?: UpdateDeliveryDetailsModel | undefined;
    isPhoneHiddenToDriver?: boolean | undefined;
    dateOffsetString?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IUpdateJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applications = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.material = _data["material"] ? UpdateJobMaterialModel.fromJS(_data["material"]) : <any>undefined;
            this.quantity = _data["quantity"] ? UpdateJobQuantityModel.fromJS(_data["quantity"]) : <any>undefined;
            this.quantityType = _data["quantityType"];
            this.customerId = _data["customerId"];
            this.jobSiteId = _data["jobSiteId"];
            this.jobSiteDetails = _data["jobSiteDetails"] ? UpdateJobSiteDetailsModel.fromJS(_data["jobSiteDetails"]) : <any>undefined;
            this.customerContactId = _data["customerContactId"];
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(UpdateJobApplicationModel.fromJS(item));
            }
            this.hourly = _data["hourly"];
            this.jobType = _data["jobType"];
            this.deliveryDetails = _data["deliveryDetails"] ? UpdateDeliveryDetailsModel.fromJS(_data["deliveryDetails"]) : <any>undefined;
            this.isPhoneHiddenToDriver = _data["isPhoneHiddenToDriver"];
            this.dateOffsetString = _data["dateOffsetString"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateJobModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        data["quantity"] = this.quantity ? this.quantity.toJSON() : <any>undefined;
        data["quantityType"] = this.quantityType;
        data["customerId"] = this.customerId;
        data["jobSiteId"] = this.jobSiteId;
        data["jobSiteDetails"] = this.jobSiteDetails ? this.jobSiteDetails.toJSON() : <any>undefined;
        data["customerContactId"] = this.customerContactId;
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        data["hourly"] = this.hourly;
        data["jobType"] = this.jobType;
        data["deliveryDetails"] = this.deliveryDetails ? this.deliveryDetails.toJSON() : <any>undefined;
        data["isPhoneHiddenToDriver"] = this.isPhoneHiddenToDriver;
        data["dateOffsetString"] = this.dateOffsetString;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateJobModel {
    material?: UpdateJobMaterialModel | undefined;
    quantity?: UpdateJobQuantityModel | undefined;
    quantityType?: QuantityType | undefined;
    customerId?: string | undefined;
    jobSiteId?: string | undefined;
    jobSiteDetails?: UpdateJobSiteDetailsModel | undefined;
    customerContactId?: string | undefined;
    applications: UpdateJobApplicationModel[];
    hourly: boolean;
    jobType: JobType;
    deliveryDetails?: UpdateDeliveryDetailsModel | undefined;
    isPhoneHiddenToDriver?: boolean | undefined;
    dateOffsetString?: string | undefined;
    notes?: string | undefined;
}

export class UpdateJobApplicationModel implements IUpdateJobApplicationModel {
    jobApplicationId?: string | undefined;
    customName?: string | undefined;
    applicationId?: string | undefined;

    constructor(data?: IUpdateJobApplicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobApplicationId = _data["jobApplicationId"];
            this.customName = _data["customName"];
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): UpdateJobApplicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobApplicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobApplicationId"] = this.jobApplicationId;
        data["customName"] = this.customName;
        data["applicationId"] = this.applicationId;
        return data;
    }
}

export interface IUpdateJobApplicationModel {
    jobApplicationId?: string | undefined;
    customName?: string | undefined;
    applicationId?: string | undefined;
}

export class SingleResponseOfJobImageModel implements ISingleResponseOfJobImageModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model?: JobImageModel | undefined;

    constructor(data?: ISingleResponseOfJobImageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? JobImageModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleResponseOfJobImageModel {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfJobImageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfJobImageModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model?: JobImageModel | undefined;
}

export class UploadJobImageModel implements IUploadJobImageModel {
    clientId!: string;
    jobId!: string;
    fileName!: string;
    image!: string;
    contentType!: string;

    constructor(data?: IUploadJobImageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.jobId = _data["jobId"];
            this.fileName = _data["fileName"];
            this.image = _data["image"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): UploadJobImageModel {
        data = typeof data === 'object' ? data : {};
        let result = new UploadJobImageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["jobId"] = this.jobId;
        data["fileName"] = this.fileName;
        data["image"] = this.image;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IUploadJobImageModel {
    clientId: string;
    jobId: string;
    fileName: string;
    image: string;
    contentType: string;
}

export class MoveJobModel implements IMoveJobModel {
    previousDriverId!: string;
    newDriverId!: string;
    deliveryDate!: Date;
    estimateEndDate!: Date;

    constructor(data?: IMoveJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousDriverId = _data["previousDriverId"];
            this.newDriverId = _data["newDriverId"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.estimateEndDate = _data["estimateEndDate"] ? new Date(_data["estimateEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MoveJobModel {
        data = typeof data === 'object' ? data : {};
        let result = new MoveJobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousDriverId"] = this.previousDriverId;
        data["newDriverId"] = this.newDriverId;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["estimateEndDate"] = this.estimateEndDate ? this.estimateEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMoveJobModel {
    previousDriverId: string;
    newDriverId: string;
    deliveryDate: Date;
    estimateEndDate: Date;
}

export class SingleResponseOfJobSiteModel implements ISingleResponseOfJobSiteModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model?: JobSiteModel | undefined;

    constructor(data?: ISingleResponseOfJobSiteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? JobSiteModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleResponseOfJobSiteModel {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfJobSiteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfJobSiteModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model?: JobSiteModel | undefined;
}

export class UpdateJobSiteModel implements IUpdateJobSiteModel {
    name?: string | undefined;
    streetAddress?: string | undefined;
    cityAddress?: string | undefined;
    googleAddress?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    locationType!: LocationType;
    notes?: string | undefined;
    lastUsedTimestamp?: Date | undefined;

    constructor(data?: IUpdateJobSiteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.streetAddress = _data["streetAddress"];
            this.cityAddress = _data["cityAddress"];
            this.googleAddress = _data["googleAddress"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.locationType = _data["locationType"];
            this.notes = _data["notes"];
            this.lastUsedTimestamp = _data["lastUsedTimestamp"] ? new Date(_data["lastUsedTimestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateJobSiteModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateJobSiteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["streetAddress"] = this.streetAddress;
        data["cityAddress"] = this.cityAddress;
        data["googleAddress"] = this.googleAddress;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["locationType"] = this.locationType;
        data["notes"] = this.notes;
        data["lastUsedTimestamp"] = this.lastUsedTimestamp ? this.lastUsedTimestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateJobSiteModel {
    name?: string | undefined;
    streetAddress?: string | undefined;
    cityAddress?: string | undefined;
    googleAddress?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    locationType: LocationType;
    notes?: string | undefined;
    lastUsedTimestamp?: Date | undefined;
}

export class ListResponseOfMaterialModel implements IListResponseOfMaterialModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: MaterialModel[];
    totalItems?: number | undefined;

    constructor(data?: IListResponseOfMaterialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["model"])) {
                this.model = [] as any;
                for (let item of _data["model"])
                    this.model!.push(MaterialModel.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): ListResponseOfMaterialModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfMaterialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.model)) {
            data["model"] = [];
            for (let item of this.model)
                data["model"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IListResponseOfMaterialModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: MaterialModel[];
    totalItems?: number | undefined;
}

export class SingleResponseOfMaterialModel implements ISingleResponseOfMaterialModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model?: MaterialModel | undefined;

    constructor(data?: ISingleResponseOfMaterialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? MaterialModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleResponseOfMaterialModel {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfMaterialModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfMaterialModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model?: MaterialModel | undefined;
}

export class CreateMaterial implements ICreateMaterial {
    name!: string;
    index!: number;

    constructor(data?: ICreateMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): CreateMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["index"] = this.index;
        return data;
    }
}

export interface ICreateMaterial {
    name: string;
    index: number;
}

export class DeviceInstallation implements IDeviceInstallation {
    installationId!: string;
    platform!: string;
    pushChannel!: string;
    deviceModel?: string | undefined;
    osVersion?: string | undefined;
    tags!: string[];

    constructor(data?: IDeviceInstallation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installationId = _data["installationId"];
            this.platform = _data["platform"];
            this.pushChannel = _data["pushChannel"];
            this.deviceModel = _data["deviceModel"];
            this.osVersion = _data["osVersion"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): DeviceInstallation {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceInstallation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installationId"] = this.installationId;
        data["platform"] = this.platform;
        data["pushChannel"] = this.pushChannel;
        data["deviceModel"] = this.deviceModel;
        data["osVersion"] = this.osVersion;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IDeviceInstallation {
    installationId: string;
    platform: string;
    pushChannel: string;
    deviceModel?: string | undefined;
    osVersion?: string | undefined;
    tags: string[];
}

export class NotificationRequest implements INotificationRequest {
    text?: string | undefined;
    action?: PushAction | undefined;
    tags!: string[];
    silent!: boolean;
    title?: string | undefined;

    constructor(data?: INotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.action = _data["action"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.silent = _data["silent"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): NotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["action"] = this.action;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["silent"] = this.silent;
        data["title"] = this.title;
        return data;
    }
}

export interface INotificationRequest {
    text?: string | undefined;
    action?: PushAction | undefined;
    tags: string[];
    silent: boolean;
    title?: string | undefined;
}

export enum PushAction {
    JobUpdate = "JobUpdate",
}

export class ListResponseOfQuantityModel implements IListResponseOfQuantityModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: QuantityModel[];
    totalItems?: number | undefined;

    constructor(data?: IListResponseOfQuantityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["model"])) {
                this.model = [] as any;
                for (let item of _data["model"])
                    this.model!.push(QuantityModel.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): ListResponseOfQuantityModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfQuantityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.model)) {
            data["model"] = [];
            for (let item of this.model)
                data["model"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IListResponseOfQuantityModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: QuantityModel[];
    totalItems?: number | undefined;
}

export class SingleResponseOfQuantityModel implements ISingleResponseOfQuantityModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model?: QuantityModel | undefined;

    constructor(data?: ISingleResponseOfQuantityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? QuantityModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleResponseOfQuantityModel {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfQuantityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfQuantityModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model?: QuantityModel | undefined;
}

export class CreateQuantity implements ICreateQuantity {
    name!: string;
    index!: number;

    constructor(data?: ICreateQuantity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): CreateQuantity {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuantity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["index"] = this.index;
        return data;
    }
}

export interface ICreateQuantity {
    name: string;
    index: number;
}

export class ListResponseOfQuarryModel implements IListResponseOfQuarryModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: QuarryModel[];
    totalItems?: number | undefined;

    constructor(data?: IListResponseOfQuarryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["model"])) {
                this.model = [] as any;
                for (let item of _data["model"])
                    this.model!.push(QuarryModel.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): ListResponseOfQuarryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfQuarryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.model)) {
            data["model"] = [];
            for (let item of this.model)
                data["model"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IListResponseOfQuarryModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: QuarryModel[];
    totalItems?: number | undefined;
}

export class SingleResponseOfQuarryModel implements ISingleResponseOfQuarryModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model?: QuarryModel | undefined;

    constructor(data?: ISingleResponseOfQuarryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? QuarryModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleResponseOfQuarryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfQuarryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfQuarryModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model?: QuarryModel | undefined;
}

export class CreateQuarry implements ICreateQuarry {
    name!: string;
    address?: string | undefined;
    index!: number;

    constructor(data?: ICreateQuarry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): CreateQuarry {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuarry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["index"] = this.index;
        return data;
    }
}

export interface ICreateQuarry {
    name: string;
    address?: string | undefined;
    index: number;
}

export class ListResponseOfUserModel implements IListResponseOfUserModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model!: UserModel[];
    totalItems?: number | undefined;

    constructor(data?: IListResponseOfUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.model = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["model"])) {
                this.model = [] as any;
                for (let item of _data["model"])
                    this.model!.push(UserModel.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): ListResponseOfUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResponseOfUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.model)) {
            data["model"] = [];
            for (let item of this.model)
                data["model"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IListResponseOfUserModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model: UserModel[];
    totalItems?: number | undefined;
}

export class UserModel implements IUserModel {
    userId!: string;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status!: UserStatus;
    role!: UserRole;
    clientId?: string | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.status = _data["status"];
            this.role = _data["role"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["status"] = this.status;
        data["role"] = this.role;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IUserModel {
    userId: string;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status: UserStatus;
    role: UserRole;
    clientId?: string | undefined;
}

export enum UserStatus {
    Active = "Active",
    Disabled = "Disabled",
}

export class UserFilterSort implements IUserFilterSort {
    sortField!: UserSortField;
    sortDescending!: boolean;
    clientId!: string;
    excludeRoles!: UserRole[];

    constructor(data?: IUserFilterSort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.excludeRoles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortField = _data["sortField"];
            this.sortDescending = _data["sortDescending"];
            this.clientId = _data["clientId"];
            if (Array.isArray(_data["excludeRoles"])) {
                this.excludeRoles = [] as any;
                for (let item of _data["excludeRoles"])
                    this.excludeRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserFilterSort {
        data = typeof data === 'object' ? data : {};
        let result = new UserFilterSort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortField"] = this.sortField;
        data["sortDescending"] = this.sortDescending;
        data["clientId"] = this.clientId;
        if (Array.isArray(this.excludeRoles)) {
            data["excludeRoles"] = [];
            for (let item of this.excludeRoles)
                data["excludeRoles"].push(item);
        }
        return data;
    }
}

export interface IUserFilterSort {
    sortField: UserSortField;
    sortDescending: boolean;
    clientId: string;
    excludeRoles: UserRole[];
}

export enum UserSortField {
    LastName = "LastName",
    FirstName = "FirstName",
}

export class SingleResponseOfUserModel implements ISingleResponseOfUserModel {
    errorMessage!: string;
    hasError!: boolean;
    message!: string;
    errorCode?: number | undefined;
    model?: UserModel | undefined;

    constructor(data?: ISingleResponseOfUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.hasError = _data["hasError"];
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
            this.model = _data["model"] ? UserModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SingleResponseOfUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new SingleResponseOfUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["hasError"] = this.hasError;
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISingleResponseOfUserModel {
    errorMessage: string;
    hasError: boolean;
    message: string;
    errorCode?: number | undefined;
    model?: UserModel | undefined;
}

export class CreateUser implements ICreateUser {
    email!: string;
    password!: string;
    firstName!: string;
    lastName!: string;
    status!: UserStatus;
    role!: UserRole;
    clientId?: string | undefined;

    constructor(data?: ICreateUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.status = _data["status"];
            this.role = _data["role"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): CreateUser {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["status"] = this.status;
        data["role"] = this.role;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface ICreateUser {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    status: UserStatus;
    role: UserRole;
    clientId?: string | undefined;
}

export class UpdateUser implements IUpdateUser {
    userId!: string;
    email?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status!: UserStatus;
    role!: UserRole;
    clientId?: string | undefined;

    constructor(data?: IUpdateUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.status = _data["status"];
            this.role = _data["role"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): UpdateUser {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["status"] = this.status;
        data["role"] = this.role;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IUpdateUser {
    userId: string;
    email?: string | undefined;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status: UserStatus;
    role: UserRole;
    clientId?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

// @ts-ignore .